import { usePushNotificationTokenSync } from '../hooks/usePushNotificationTokenSync';

export const PushNotificationsTokenSync = () => {
  usePushNotificationTokenSync();

  return null;
};
